import { Icon, useT } from "@mmm/ui";
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchInput({ value, onChange, placeholder }: SearchInputProps) {
  const t = useT();
  return (
    <div className="mmm-search-input-wrap">
      <Icon name="search" />
      <input
        type="text"
        className="mmm-input"
        value={value}
        placeholder={placeholder ?? t("common.search")}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
